import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-179">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-180">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-181" />
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden z-10" data-id="element-182">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0" data-id="element-183">
              <h2 className="text-xl font-bold text-charcoal font-serif" data-id="element-184">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-185">
                <X className="h-5 w-5 text-charcoal-light" data-id="element-186" />
              </button>
            </div>
            <div className="px-6 py-5 overflow-y-auto text-sm text-charcoal-light leading-relaxed space-y-4" data-id="element-187">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}